module.exports = __webpack_public_path__ + "img/ic_advanceSearch.8fc57c25.svg";